import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { InformatTheme } from "pu-crossproduct-components/build/themes";
import { InformatUsernamelogin2FactorMessage } from "../components/05pages/informat/InformatUsernamelogin2FactorMessage/InformatUsernamelogin2FactorMessage";
import { Informat404 } from "../components/05pages/informat/Informat404/Informat404";
import { InformatRrnrError } from "../components/05pages/informat/InformatRrnrError/InformatRrnrError";
import { AccountPicker } from "../pages/informat/AccountPicker/AccountPicker";
import { useTranslation } from "react-i18next";

function getFaviconEl(id:string):HTMLLinkElement {
    return document.getElementById(id) as HTMLLinkElement;
}

function getTitleEl():HTMLTitleElement {
    return document.getElementById("page-title") as HTMLTitleElement;
}

export const InformatRouter: React.FC = props => {
    const { url } = useRouteMatch();
    const { t } = useTranslation();

    const faviconEl = getFaviconEl("favicon"); // Accessing favicon element
    if (faviconEl) {    
        const faviconUrl = "/informat-favicon.ico"
        faviconEl.href = faviconUrl;
    }

    const appleFaviconEl = getFaviconEl("apple-favicon"); // Accessing apple-favicon element
    if (appleFaviconEl) {    
        const faviconUrl = "/informat-logo192.png"
        appleFaviconEl.href = faviconUrl;
    }

    const titleEl = getTitleEl(); // Accessing favicon element
    if (faviconEl) {    
        titleEl.innerHTML = t("twoFactorInformatWindowTitle");
    }

    return <InformatTheme>
        <Switch>
            <Route exact={true} path={`${url}/2FA`}>
                <InformatUsernamelogin2FactorMessage />
            </Route>

            <Route exact={true} path={`${url}/2FA/RrnrError`}>
                <InformatRrnrError />
            </Route>

            <Route exact={true} path={`${url}/SelectAccount`}>
                <AccountPicker />
            </Route>

            <Route path={[`${url}/`, `${url}/*`]}>
                <Informat404 />
            </Route>
        </Switch>
    </InformatTheme>
}
